interface BrandWatermarkProps {
  variant?: 'light' | 'dark' | 'subtle';
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' | 'center';
  size?: 'small' | 'medium' | 'large';
}

export default function BrandWatermark({ 
  variant = 'subtle', 
  position = 'top-right',
  size = 'medium' 
}: BrandWatermarkProps) {
  const sizeClasses = {
    small: 'w-16 h-16',
    medium: 'w-24 h-24',
    large: 'w-32 h-32'
  };

  const positionClasses = {
    'top-left': 'top-8 left-8',
    'top-right': 'top-8 right-8',
    'bottom-left': 'bottom-8 left-8',
    'bottom-right': 'bottom-8 right-8',
    'center': 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'
  };

  const variantClasses = {
    light: 'opacity-10',
    dark: 'opacity-5',
    subtle: 'opacity-[0.03]'
  };

  return (
    <div className={`absolute ${positionClasses[position]} ${sizeClasses[size]} ${variantClasses[variant]} pointer-events-none select-none`}>
      <img
        src="https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/400664175eef7daba939234b6dd4e0a2.png"
        alt="Gi2 Logo"
        className="w-full h-full object-contain"
        draggable={false}
      />
    </div>
  );
}
